import { RecommendationType } from "../enums";
import { ApiFilters } from "../types/model.types";

export const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const type = convertToRecommendationType(params.get("type"));
  const storeId = params.get("storeId") || "";
  const productId = params.get("productId") || "";
  const jsonFilters = recommendationEncodedQuery({
    storeCodes: storeId ? [storeId.toString()] : [],
  });
  return { type, storeId, jsonFilters, productId };
};

export const convertToRecommendationType = (
  typeStr: string | null,
): RecommendationType => {
  if (!typeStr) return RecommendationType.RECOMMENDED_FOR_YOU;

  const normalized = typeStr?.toUpperCase();

  const match = Object.values(RecommendationType).find(
    (val) => val === normalized,
  );

  return match ?? RecommendationType.RECOMMENDED_FOR_YOU;
};


export const recommendationEncodedQuery = (obj: ApiFilters) => {
  return Object.entries(obj)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return `${key}:[${value.join(',')}]`;
      }
      if (typeof value === 'object' && value !== null) {
        const inner = Object.entries(value)
          .map(([k, v]) => `${k}:${v}`)
          .join(',');
        return `${key}:{${inner}}`;
      }
      return `${key}:${value}`;
    })
    .join('&&');
};
